'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  ", ";\n\n  ", "\n\n  &:hover {\n    ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  ",
    ";\n\n  ",
    "\n\n  &:hover {\n    ",
    ";\n  }\n"])), function (_a) {
    var useHoverStyles = _a.useHoverStyles, theme = _a.theme;
    return useHoverStyles
        && "background-color: " + theme.colors.$greyLight + ";\n     border-radius: 4px;\n     height: 92px;\n     padding: 11px 14px 7px 14px;";
}, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && "\n    pointer-events: none;\n  ";
}, function (_a) {
    var useHoverStyles = _a.useHoverStyles, theme = _a.theme;
    return useHoverStyles
        && "background-color: " + theme.colors.$white + ";\n       box-shadow: 0px 0px 0px 0px " + theme.colors.$greyDark + "0D,\n       0px 4px 8px 0px " + theme.colors.$greyDark + "0D,\n       0px 8px 10px 0px " + theme.colors.$greyDark + "0D,\n       0px 4px 70px 0px " + theme.colors.$greyDark + "26;\n       cursor: pointer; ";
});
var TextContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font-size: 16px;\n  margin-right: 8px;\n  color: ", ";\n"], ["\n  font-size: 16px;\n  margin-right: 8px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Title = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 16px/19px ", ";\n  color: ", ";\n  padding-bottom: 8px;\n  font-weight: ", ";\n  ", ";\n"], ["\n  font: 16px/19px ", ";\n  color: ", ";\n  padding-bottom: 8px;\n  font-weight: ", ";\n  ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var titleType = _a.titleType;
    return titleType;
}, function (_a) {
    var useHoverStyles = _a.useHoverStyles;
    return useHoverStyles
        && "font-weight: 700;\n  }";
});
var Subtitle = styled__default(Title)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.$sharedGreyDark;
});
var Link = styled__default.a(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/19px ", ";\n  color: ", ";\n"], ["\n  font: 500 16px/19px ", ";\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var isPhoneNumber = _a.isPhoneNumber, theme = _a.theme;
    return (isPhoneNumber
        ? theme.colors.fontColor + "; text-decoration: none;"
        : theme.colors.$secondary);
});
var ActionButton = styled__default.button(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  background: none;\n  border: none;\n  padding: 0;\n  color: ", "\n  font-size: 14px;\n  font-weight: 400px;\n  cursor: pointer;\n  text-decoration: underline;\n  &:hover {\n    text-decoration:none\n  }\n  display:flex;\n  justify-content: flex-start;\n  -webkit-box-pack: start;\n"], ["\n  background: none;\n  border: none;\n  padding: 0;\n  color: ",
    "\n  font-size: 14px;\n  font-weight: 400px;\n  cursor: pointer;\n  text-decoration: underline;\n  &:hover {\n    text-decoration:none\n  }\n  display:flex;\n  justify-content: flex-start;\n  -webkit-box-pack: start;\n"])), function (_a) {
    var theme = _a.theme;
    return (theme.colors.palette.systemPink + ";");
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

var IconBlock = function (_a) {
    var title = _a.title, _b = _a.titleType, titleType = _b === void 0 ? 'normal' : _b, icon = _a.icon, iconType = _a.iconType, subtitle = _a.subtitle, linkText = _a.linkText, linkRef = _a.linkRef, _c = _a.className, className = _c === void 0 ? 'icon-block' : _c, _d = _a.dataCy, dataCy = _d === void 0 ? 'icon-block' : _d, _e = _a.dataTestId, dataTestId = _e === void 0 ? 'icon-block' : _e, isPhoneNumber = _a.isPhoneNumber, useHoverStyles = _a.useHoverStyles, onClick = _a.onClick, shouldOpenInNewTab = _a.shouldOpenInNewTab, isDisabled = _a.isDisabled, actionText = _a.actionText, action = _a.action, onActionClick = _a.onActionClick;
    var handleOnClick = React.useCallback(function (e) {
        e.stopPropagation();
        if (onClick)
            onClick();
    }, [onClick]);
    var handleOnActionClick = React.useCallback(function (event) {
        event.stopPropagation();
        if (onActionClick)
            onActionClick();
    }, [onActionClick]);
    var handleLinkRedirect = React.useCallback(function (event) {
        event.stopPropagation();
    }, []);
    var iconProp = React.useMemo(function () { return (iconType ? [iconType, icon] : ['fas', icon]); }, [iconType, icon]);
    return (React__default.createElement(Container, { isDisabled: isDisabled, "data-cy": dataCy, "data-testid": dataTestId, className: className, useHoverStyles: useHoverStyles, onClick: handleOnClick },
        React__default.createElement(Icon, { className: "icon-block-icon", icon: iconProp }),
        React__default.createElement(TextContainer, { className: "icon-block-text-container", "data-cy": dataCy + "-text-container" },
            title && (React__default.createElement(Title, { className: "icon-block-title", useHoverStyles: useHoverStyles, titleType: titleType }, title)),
            subtitle && React__default.createElement(Subtitle, { className: "icon-block-subtitle" }, subtitle),
            linkText && linkRef && (React__default.createElement(Link, { className: "icon-block-link", href: isPhoneNumber ? "tel:+" + linkRef : linkRef, isPhoneNumber: isPhoneNumber, onClick: handleLinkRedirect, target: shouldOpenInNewTab ? '_blank' : '_self' }, linkText)),
            action && actionText && onActionClick && (React__default.createElement(ActionButton, { type: "button", "data-testid": "icon-block-action", onClick: handleOnActionClick }, actionText)))));
};

exports.IconBlock = IconBlock;
